import {FilesService} from "@/services/files";
import {formatDate} from "@/utils/dates";

import EmptyState from '@/components/empty-state';
import ListItemFile from '@/components/list-item/list-item-file';
import ListItemFileLabTest from '@/components/list-item/list-item-file-labtest';
import ListItemFileLabresult from "@/components/list-item/list-item-file-labresult";
import ListItemPxMaterial from "@/components/list-item/list-item-file-pxmaterial";

import HeaderFunctionMixin from '@/mixins/header-functions-mixin'
import TitleMixin from '@/mixins/title-mixin';

import {
  PageTypes,
} from "@/reference";

export default {
  name: 'root-files',
  mixins: [HeaderFunctionMixin, TitleMixin],
  components: {EmptyState},
  data() {
    return {
      error: null,
      search: ''
    };
  },
  computed: {
    filteredFiles() {
      if (this.search === '') return this.files;

      return this.files
        .filter((file) => {
          const fullDate = formatDate(file.received, 'MMMM DD, YYYY');

          return new RegExp(this.search.replace(' ', '|'), 'i').test(
            (this.computedTitle(file) || '') +
            (file.patientname || '') +
            fullDate.replace(/[, ]+/g, '|'),
          )
        })
    },
  },
  methods: {
    async fetchFileURL(token, uploadid) {
      this.error = null;
      try {
        const {data} = await FilesService.getFileURL(token, uploadid);
        if (!data) {
          throw Error();
        }
        window.open(`${data.url}`, '_blank');
      } catch (e) {
        this.error = 'An unexpected error occured on viewing your file.';
      }
    },
    getFileComponent(file) {
      switch (file.pagetype) {
        case PageTypes.labtest:
          return ListItemFileLabTest;
        case PageTypes.__labresults:
          return ListItemFileLabresult;
        case PageTypes.educ:
          return ListItemPxMaterial;
        default:
          return ListItemFile;
      }
    },
  },
}